import {
  ModalContainer,
  SectionHeader,
  SwitchAppButton,
  SwitchAppIconButton,
} from "../../../components";
import { countries } from "../../../constants";
import {
  HookFormCheckbox,
  HookFormSelect,
  SubmitButton,
  TextInput,
} from "../../../hook-form";
import { IAddNewBusinessFormViewProps } from "./AddNewBusiness";

export const View = ({
  activeMerchantName,

  isModalOpen,
  closeModal,

  formValues,
  errors,
  handleSubmit,
  register,
}: IAddNewBusinessFormViewProps) => {
  return (
    <form onSubmit={handleSubmit}>
      <ModalContainer
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        modalHeader={
          <SectionHeader
            title="Add A New Business"
            subtitle="Add a new business to your SwitchApp account"
            renderRight={
              <SubmitButton
                size="sm"
                className="ml-5 mr-5 pl-5 pr-5"
                showChildrenWithLoadingIcon
              >
                Add A New Business
              </SubmitButton>
            }
          />
        }
      >
        <TextInput
          name="merchant_name"
          label="Business Name"
          infoIconText="The name of the new business that customers will see"
          type="text"
          register={register}
          errors={errors}
        />

        <TextInput
          name="business_email_address"
          label="Business Email"
          infoIconText="The official email of this business"
          type="text"
          register={register}
          errors={errors}
        />

        <HookFormSelect
          name="country"
          label="Country Where Business Is Located"
          selectItems={[]}
          selectGroupedItems={countries}
          register={register}
          errors={errors}
          // disabled={formValues.link_account_verification_with_main_account}
        />

        <HookFormCheckbox
          name="copy_settings_from_main_account"
          label="Copy Settings From Currently Active Account"
          containerClassName=""
          infoIconText="Clone account settings from this account"
          register={register}
          errors={errors}
        />

        <HookFormCheckbox
          name="link_account_verification_with_main_account"
          label="Link Verification With Selected Account"
          containerClassName="pb-5"
          infoIconText={
            <>
              This will{" "}
              <strong className="text-danger font-ctm--bold">VERIFY</strong> the
              newly created account if you have{" "}
              <strong className="text-warning font-ctm--bold">owner</strong>{" "}
              access rights to{" "}
              <strong className="font-ctm--bolder text-teal">
                {activeMerchantName}
              </strong>
              , and it is already verified. <br />
              It will also add all users of{" "}
              <strong className="font-ctm--bolder text-teal">
                {activeMerchantName}
              </strong>{" "}
              with{" "}
              <strong className="text-warning font-ctm--bold">owner</strong>{" "}
              access to the new account's team.
            </>
          }
          register={register}
          errors={errors}
        />

        {formValues.link_account_verification_with_main_account ? null : (
          <>
            <TextInput
              name="phone_number"
              label="Business Phone Number"
              infoIconText="The phone number of this business"
              type="text"
              register={register}
              errors={errors}
            />

            <TextInput
              name="bvn"
              label="Business Bvn"
              infoIconText="The BVN tied to this business for regulatory purposes"
              type="text"
              register={register}
              errors={errors}
            />

            <TextInput
              name="nin"
              label="Business NIN"
              infoIconText="The NIN tied to this business for regulatory purposes"
              type="text"
              register={register}
              errors={errors}
            />
          </>
        )}

        {/* <HookFormSelect
          name="payout_tag"
          label="Preferred Payout Account"
          infoIconText="Bank account where sales of this product will be paid out to. Leave empty if you want it to be paid into your primary acct. number."
          showSkeleton={isLoadingBankAccounts}
          selectItems={[]}
          selectGroupedItems={
            activePayoutTags.map((acct) => ({
              groupLabel: `${acct.account_name} - ${acct.account_number} (${acct.bank_name})`,
              options: acct.bank_account_tags.map((tag) => ({
                text: `${tag.tag_name}`,
                value: tag.id,
              })),
            })) || []
          }
          register={register}
          errors={errors}
        /> */}

        <div className="flex-container invoice-bottom justify-content--end align-items--center">
          <div className="button-group">
            {/* <SwitchAppButton size="sm" kind="secondary" onClick={closeModal}>
              Cancel
            </SwitchAppButton>

            <SubmitButton size="sm" showChildrenWithLoadingIcon>
              Save
            </SubmitButton> */}
          </div>
        </div>
      </ModalContainer>
    </form>
  );
};
